import { FC } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { useSSRContext } from "../../../../context/SSRContext";
import { getSelectedSSRItems } from "../../../../utils";
import { formatNumber, formulateName } from "src/utility";

const PassengerSelectionTile: FC<{ passenger: any; isActive: boolean; plain?: boolean }> = ({ passenger, isActive, plain }) => {
  const { t } = useTranslation();
  const firstName = formulateName(passenger?.firstName);
  const nameInitial = firstName?.charAt(0).toUpperCase();
  const { cursor, getSSRItem } = useSSRContext();
  const ssrItem = getSSRItem(cursor.ssrType, passenger?.value);
  const selectedSSRItems = getSelectedSSRItems(ssrItem);
  const hasSSR = selectedSSRItems.length > 0;
  const totalPrice = selectedSSRItems.reduce((sum, item) => sum + (item.price ?? 0), 0);
  const currency = selectedSSRItems[0]?.currency;
  return (
    <div
      className={classNames(
        "flex h-full w-full cursor-pointer items-center gap-3 select-none",
        !plain && "bg-background-default rounded-sm p-3 outline-1 transition-all duration-300",
        !plain && (isActive ? "outline-border-active shadow-sm" : "outline-border-default"),
        !plain && !hasSSR && "outline-dashed",
      )}
    >
      <div
        className={classNames(
          "flex size-8 shrink-0 items-center justify-center rounded-full text-xs font-semibold",
          hasSSR ? "bg-background-primary text-font-inverted" : "bg-background-minimal text-font-subtle",
        )}
      >
        {nameInitial}
      </div>
      <div className="flex h-full w-full flex-1 items-center justify-between gap-2">
        <div className="flex h-full flex-1 flex-col gap-0.5">
          <span className="text-14 text-font-default font-semibold">{firstName}</span>
          <span className="text-font-subtle text-xs font-normal">{`${t(`Flights.details.passengerType.${passenger?.type?.toLowerCase()}`)}`}</span>
          {hasSSR && <span className="text-font-active text-xs font-semibold">{`${formatNumber(totalPrice)} ${currency}`}</span>}
        </div>
        {hasSSR && (
          <div className="bg-background-primary-lighter text-font-active flex items-center gap-1 rounded-sm px-2 py-1 text-xs font-semibold">
            {selectedSSRItems.map((item) => (
              <span key={item.code}>{item.code}</span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default PassengerSelectionTile;
